module.exports = __webpack_public_path__ + "static/media/diag04.0eed5feb.jpg";